
import { RevLink } from '@ds/components/Link'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { camelize } from 'humps'

import ProgressBar from '@core/components/ProgressBar'
import { MAX_RATING } from '@reviews/constants'
import { trackClick } from '@tracking/events'

import { TRACKING_ZONE } from '../../constants'

import translations from './RatingCategories.translations'

export default {
  components: {
    IconChevronDown,
    ProgressBar,
    RevLink,
  },

  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isCategoriesListDisplayed: false,
    }
  },

  computed: {
    translations: () => translations,
    MAX_RATING: () => MAX_RATING,
    formattedCategories() {
      return this.categories.map((category) => {
        return {
          ...category,
          percentage: (100 * category.average) / MAX_RATING,
          name: camelize(category.name),
        }
      })
    },
    toggleCtaText() {
      return this.isCategoriesListDisplayed
        ? this.$t(translations.showLess)
        : this.$t(translations.showMore)
    },
    accordionIconClass() {
      return this.isCategoriesListDisplayed
        ? 'rotate-180 transition-transform'
        : ''
    },
  },
  methods: {
    toggleCategories() {
      trackClick({
        name: this.isCategoriesListDisplayed
          ? 'see_less_rating_categories'
          : 'see_more_rating_categories',
        zone: TRACKING_ZONE,
      })
      this.isCategoriesListDisplayed = !this.isCategoriesListDisplayed
    },
  },
}
